import React from 'react'

import { Subtitle, SmallDetail } from 'components/base/Text'

import Confirm from 'components/Utils/Modal/Confirm'
import { makeToggleable } from 'components/Utils/toggleable'

type DeleteOrganizationModalProps = {
  openModal: () => void
  onConfirm: () => void
  isModalOpen: boolean
  closeModal: (event: React.ChangeEvent<HTMLDivElement>) => void
  children: React.ReactNode
}

function DeleteOrganizationModal({
  openModal,
  onConfirm,
  isModalOpen,
  closeModal,
  children,
}: DeleteOrganizationModalProps) {
  return (
    <div>
      <Confirm
        show={isModalOpen}
        onConfirm={(event: React.ChangeEvent<HTMLDivElement>) => {
          onConfirm()
          closeModal(event)
        }}
        onCancel={closeModal}
      >
        <div className="text-align-left">
          <Subtitle style={{ lineHeight: '30px' }}>
            Are you sure you want to delete your team?
          </Subtitle>

          <SmallDetail
            style={{ lineHeight: '16px' }}
            className="margin-top-medium"
          >
            Once confirmed, this action will be effective immediately and you
            will lose access to all your account and team data.{' '}
            <strong>This action cannot be undone.</strong>
          </SmallDetail>
          <SmallDetail>
            You will receive a full backup of your team's data and each member
            will receive an individual backup as well.
          </SmallDetail>
        </div>
      </Confirm>
      <div onClick={openModal}>{children}</div>
    </div>
  )
}

const ConnectedUserRemovalModal = makeToggleable({
  attrName: 'isModalOpen',
  toggleOnName: 'openModal',
  toggleOffName: 'closeModal',
  toggleName: 'toggleModal',
  defaultValue: false,
})(DeleteOrganizationModal)

export default ConnectedUserRemovalModal
